var _g, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChartUp = function SvgChartUp(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.182 0.727295H13.4547C12.8522 0.727295 12.3638 1.21571 12.3638 1.8182V14.1818C12.3638 14.7843 12.8522 15.2727 13.4547 15.2727H14.182C14.7844 15.2727 15.2729 14.7843 15.2729 14.1818V1.8182C15.2729 1.21571 14.7844 0.727295 14.182 0.727295Z",
    stroke: "#082344",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.36359 5.09094H7.63632C7.03383 5.09094 6.54541 5.57936 6.54541 6.18185V14.1819C6.54541 14.7843 7.03383 15.2728 7.63632 15.2728H8.36359C8.96609 15.2728 9.4545 14.7843 9.4545 14.1819V6.18185C9.4545 5.57936 8.96609 5.09094 8.36359 5.09094Z",
    stroke: "#082344",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.54548 9.45459H1.8182C1.21571 9.45459 0.727295 9.94301 0.727295 10.5455V14.1819C0.727295 14.7844 1.21571 15.2728 1.8182 15.2728H2.54548C3.14797 15.2728 3.63639 14.7844 3.63639 14.1819V10.5455C3.63639 9.94301 3.14797 9.45459 2.54548 9.45459Z",
    stroke: "#082344",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChartUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chart-up.167150b5.svg";
export { ForwardRef as ReactComponent };